import { render, staticRenderFns } from "./UserLocation.vue?vue&type=template&id=2f7f4456"
import script from "./UserLocation.vue?vue&type=script&lang=js"
export * from "./UserLocation.vue?vue&type=script&lang=js"
import style0 from "./UserLocation.vue?vue&type=style&index=0&id=2f7f4456&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports